import React from "react";
import { safeBuilderHtml } from "~/lib/builder-utils";

interface ProseProps {
  content: unknown;
}

export const Prose = ({ content }: ProseProps) => {
  const htmlContent = safeBuilderHtml(content);

  return (
    <div
      className="prose prose-gray mx-auto w-full"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    ></div>
  );
};
